import type { CmpHider } from './types';

export const quantcast: CmpHider = {
  id: 'quantcast',
  label: 'Quantcast Choice',
  css: `
      /* Quantcast Choice (Quantcast Choice CMP, __tcfapi): the whole consent UI
         is wrapped in #qc-cmp2-container, which holds the consent dialog plus a
         persistent fixed "Privacy/cog" relink button (.qc-cmp2-persistent-link)
         that floats over the page even after consent. Hiding the container
         removes both. The consent dialog mounts in .qc-cmp-cleanslate with a
         fixed dimming backdrop (.qc-cmp2-bg) and the dialog shell
         (.qc-cmp2-ui-container); hide those too so an open dialog leaves no
         faded overlay. Quantcast locks page scroll via an inline
         "overflow: hidden" on <body> rather than a class — the
         html/html-body[style*="overflow"] release rule above (added for
         Cookiebot) already out-specifies that inline lock, so no extra
         scroll-lock rule is needed here. */
      #qc-cmp2-container,
      .qc-cmp2-container,
      .qc-cmp2-persistent-link,
      .qc-cmp-cleanslate .qc-cmp2-bg,
      .qc-cmp-cleanslate .qc-cmp2-ui-container { display: none !important; }
  `,
};
